<template>
  <transition name="fade">
    <div v-if="state.isVisible" id="alert">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div :class="`alert alert-dismissible fade show alert-${state.type}`">
              <span style="white-space: pre-wrap">{{ state.message }}</span>
              <button type="button" class="btn-close" @click="onClose"></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import useFlashMessage from '../../composables/useFlashMessage';

export default {
  name: 'FlashMessage',
  setup() {
    const { state, onClose } = useFlashMessage();

    return {
      state,
      onClose,
    };
  },
};
</script>

<style scoped>
.fade-enter-active {
}

.fade-leave-active {
  transition: opacity 0.3s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
